import { Button, Card, Space } from 'antd';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { SubSubtitle, Title } from '../../components';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SelectProductos from '../../components/SelectProductos';
import EmpresaContext from '../../context/empresa-context';
import { instanceRef } from '../../utils/axios';

const CrearCotizacion = () => {
  const [selectedProducto, setSelectedProducto] = useState();
  const [detalleProductoList, setDetalleProductoList] = useState();

  const history = useHistory();
  const { productos, updateProducto, empresa } = useContext(EmpresaContext);
  const tipoCotizacion = 'individual';
  const llevaracotizarproducto = () => {
    updateProducto(selectedProducto);
    history.push({
      pathname: '/cotizacionamedida',
      state: { tipoCotizacion }
    });
  };

  const getDetallesEmpresaProducto = useCallback(async () => {
    try {
      const response = await instanceRef.instance.get(
        `/empresaproducto/detalleproducto/${empresa.id}`
      );
      if (response.data?.data) {
        setDetalleProductoList(response.data?.data);
      }
    } catch (error) {
      // return error;
    }
  }, [empresa]);

  useEffect(() => {
    getDetallesEmpresaProducto();
  }, [getDetallesEmpresaProducto]);

  return (
    <ResponsiveContainer>
      <LogosEmpresaAseguradora soloEmpresa> </LogosEmpresaAseguradora>
      <Card>
        <Title>Cotizar</Title>
        <SubSubtitle>
          Seleccione el producto para generar la cotización
        </SubSubtitle>
        <SelectProductos
          productos={productos}
          selectedProducto={selectedProducto}
          setSelectedProducto={setSelectedProducto}
          tipoCotizacion={tipoCotizacion}
          detalleProductoList={detalleProductoList}
        />
        <br />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Space>
            <Button
              type="primary"
              shape="round"
              htmlType="submit"
              disabled={!selectedProducto}
              onClick={llevaracotizarproducto}
            >
              Empezar
            </Button>
          </Space>
        </div>
      </Card>
    </ResponsiveContainer>
  );
};

export default CrearCotizacion;
